// redux
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store';
import { setEdicion } from '../../store/slices/edicion';
import { setModulo } from '../../store/slices/modulo';
import Admin from './Admin';
// Layout
// import Admin from './Admin';
import Client from './Client';

const Curso = () => {

    const dispatch = useDispatch<AppDispatch>();

    const { modulo } = useSelector((state: RootState) => state.modulo);
    const { edicion } = useSelector((state: RootState) => state.edicion);

    useEffect(() => {
        return () => {
            dispatch(setEdicion(false))
            dispatch(setModulo({cid: '', mid: '', modulo: 0, nombre: 'Noticias'}))
        }
    }, [dispatch])    

    return edicion ? <Admin modulo={modulo} /> : <Client modulo={modulo} />
}

export default Curso;